"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-xl font-semibold">Une erreur est survenue</h2>
      <div className="max-w-xl rounded-lg border border-red-200 bg-red-50 p-4 text-sm">
        <p className="font-mono text-red-700">{error.message}</p>
        {process.env.NODE_ENV === "development" && error.stack && (
          <pre className="mt-2 max-h-40 overflow-auto text-xs text-red-500">
            {error.stack}
          </pre>
        )}
      </div>
      <button
        onClick={reset}
        className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
      >
        Réessayer
      </button>
    </div>
  );
}
